// extracted by mini-css-extract-plugin
module.exports = {"taxNotice":"src-pages-electronicTaxBureau-components-CompanyInput-__index__taxNotice--vDkhB"};